import { Box, Button, CircularProgress, Divider, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTrackerContext } from '../../../context';
import { theme } from 'config/theme';
import CloseLineIcon from 'remixicon-react/CloseLineIcon';
import { TaskFormData } from '../../../hooks/useAddTaskForm';
import TaskDetailsForm from './TaskDetailsForm';
import { ConfigEntryType } from 'config/config';
import { TaskType } from '../../../queries/useTrackerTasksQuery';
import { useFormContext } from 'react-hook-form';
import { useTrackerDetailsQuery } from '@buildwise/libs/trackers/queries';

type AddTaskFormProps = {
  task?: TaskType;
  taskFields: ConfigEntryType[];
  onSubmit: () => void;
};

function AddTaskForm({ taskFields, onSubmit }: AddTaskFormProps) {
  const {
    state: { selectedTask, trackerId },
    dispatch,
  } = useTrackerContext();
  const { tracker } = useTrackerDetailsQuery({
    trackerId,
    shouldFetch: false,
  });
  const {
    formState: { isSubmitting },
  } = useFormContext<TaskFormData>();
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      overflow="hidden"
      height="100%"
    >
      <>
        <StickyContainer>
          <Box display="flex" alignItems="center" justifyContent="space-between" p={1}>
            <Box display="flex" alignItems="center" gap={0.5}>
              <Typography
                variant="h5"
                sx={(theme) => ({
                  color: theme.palette.custom.tuna,
                  fontSize: 18,
                  fontWeight: 700,
                  ml: selectedTask ? 1 : 1,
                })}
              >
                {selectedTask ? `Edit Task` : `Add Task`}
              </Typography>
            </Box>
            <IconButton
              size="small"
              onClick={() => {
                dispatch({ payload: { isOpenedTaskForm: false } });
              }}
            >
              <CloseLineIcon color={theme.palette.custom.paleSky} />
            </IconButton>
          </Box>
          <Divider />
        </StickyContainer>
        <Box p={2} height="100%" overflow="auto">
          <TaskDetailsForm
            trackerFieldsConfigName={tracker?.configNameForInputFields || ''}
            taskFields={taskFields}
          />
        </Box>
        <Box position="sticky" bottom={0}>
          <Divider />
          <Box display="flex" justifyContent={'flex-end'} gap={1} p={2}>
            <Button variant="contained" onClick={onSubmit} disabled={isSubmitting}>
              {isSubmitting ? (
                <CircularProgress
                  sx={(theme) => ({ color: theme.palette.custom.black })}
                  size={20}
                />
              ) : (
                'Save'
              )}
            </Button>
          </Box>
        </Box>
      </>
    </Box>
  );
}

const StickyContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.custom.white,
  position: 'sticky',
  top: 0,
  zIndex: 1,
}));

export default AddTaskForm;
